// extracted by mini-css-extract-plugin
export default {"compiler":"CollectionCompilerTemplate-module__compiler___VgQou","compiler__content":"CollectionCompilerTemplate-module__compiler__content____RUvu"};